module.exports = __webpack_public_path__ + "static/media/img3.f7d815fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/gallery-2/img3.jpg
// module id = 206
// module chunks = 0